import * as React from 'react'

import { cn } from '@/lib/utils'

export interface IInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  enableScrollUpdate?: boolean
  outerClassName?: string
  pre?: React.ReactNode
  suffix?: React.ReactNode
}

const Input = React.forwardRef<HTMLInputElement, IInputProps>(
  ({ className, outerClassName, type, pre, suffix, ...props }, ref) => {
    return (
      <div
        className={cn('relative flex size-full items-center', outerClassName)}
      >
        {pre && (
          <div className="absolute inset-y-0 left-0 ml-2 flex w-6 items-center">
            {pre}
          </div>
        )}
        <input
          type={type}
          className={cn(
            'flex h-10 w-full rounded-md bg-new_ui-6 border border-transparent focus-visible:border-new_ui-20 px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-base',
            className,
            {
              'pl-8': !!pre,
              'pr-10': type === 'number' || !!suffix,
            },
          )}
          ref={ref}
          {...props}
        />
        {suffix && (
          <div className="absolute inset-y-0 right-2 flex items-center">
            {suffix}
          </div>
        )}
      </div>
    )
  },
)
Input.displayName = 'Input'

export { Input }
